module.exports = __webpack_public_path__ + "static/media/service2.2c104151.svg";